module.exports = __webpack_public_path__ + "static/media/receiptBanner.8f5c15fe.png";